import React from 'react';
import { registerIcons } from '@fluentui/style-utilities';
import { SparkeSVGIcon } from './assets/sparkle-svg-icon';
import { SquareVideoSVGIcon } from './assets/square-video-svg-icon';
import { CopilotSVGIcon } from './assets/copilot-svg-icon';

registerIcons({
  icons: {
    'custom-icon-sparkle': <SparkeSVGIcon />,
    'square-video-svg': <SquareVideoSVGIcon />,
    'copilot-svg': <CopilotSVGIcon />,
  },
});

export const CustomFluentUIIcons = {
  SparkeSVGIcon: 'custom-icon-sparkle',
  SquareVideoSVGIcon: 'square-video-svg',
  CopilotSVGIcon: 'copilot-svg',
};
